import {
  Delimiter,
  Countries,
  Country,
  Currency,
  CurrencyTools,
  Language,
} from "../..";
import { ImagineConfig } from "@imagine/config";

const getSupportedLanguages = () => {
  return ImagineConfig.supportedLanguages as Language[];
};

const getSupportedCountries = () => {
  return ImagineConfig.supportedCountries as Country[];
};

const getSupportedCurrencies = () => {
  const currencies: Currency[] = [];
  ImagineConfig.supportedCountries.forEach((country) => {
    const currency = CurrencyTools.getCountryCurrency(country as Country);
    if (currency) {
      if (!currencies.includes(currency)) {
        currencies.push(currency);
      }
    }
  });
  return currencies;
};

/**
 * Ensures that the returned language is valid. Will return the default language, if passed
 * language is not supported.
 * @param language
 * @returns
 */
const getValidLanguage = (language: string) => {
  let sanitizedLanguage = language;
  if (language === "da-DK") sanitizedLanguage = "da";
  if (ImagineConfig.supportedLanguages.includes(sanitizedLanguage))
    return sanitizedLanguage;
  return ImagineConfig.defaultLanguage;
};

/**
 * Get the language tag that for the selected user language. Uses BCP-47 format that is supported by
 * the Intl API.
 * @param language
 * @returns
 */
const getLanguageTag = (language: string) => {
  switch (language) {
    case "da":
      return "da-DK";
    case "en-GB":
      return "en-GB";
    default:
      return [];
  }
};

const getDefaultCountryLanguage = (country: Country): Language => {
  switch (country) {
    case "DK":
      return "da";
    default:
      return "en-GB";
  }
};

/**
 * Get the iso code of the country.
 * @param country
 * @returns
 */
const getCountryIsoCode = (country: Country) => {
  const code = Countries.find((c) => c.country === country);
  if (code === undefined) {
    console.error("Country not supported: " + country);
    return "208";
  }
  return code.isoCode;
};

const getCountry = (isoCode: string) => {
  const country = Countries.find((c) => c.isoCode === isoCode);
  if (country === undefined) {
    console.error("ISO code not supported: " + isoCode);
    return "DK";
  }
  return country.country;
};

const isCountrySupported = (country: string) => {
  return ImagineConfig.supportedCountries.includes(country as Country);
};

const getDelimiter = (language: Language): Delimiter => {
  switch (language) {
    case "da":
      return ",";
    default:
      return ".";
  }
};

export const I18nTools = {
  getSupportedLanguages,
  getSupportedCountries,
  getSupportedCurrencies,
  getValidLanguage,
  getLanguageTag,
  getDefaultCountryLanguage,
  getCountryIsoCode,
  getCountry,
  isCountrySupported,
  getDelimiter,
};
